import { render, staticRenderFns } from "./ImageGalleryWidget.vue?vue&type=template&id=6c3daa2b&"
import script from "./ImageGalleryWidget.vue?vue&type=script&lang=js&"
export * from "./ImageGalleryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports